import { request as apiRequest, BaseResponse } from '../api';

// 会话状态枚举
export enum SessionStatus {
  ACTIVE = 1,
  COMPLETED = 2,
  PAUSED = 3,
  CANCELLED = 4
}

// 消息类型枚举
export enum MessageType {
  TEXT = 'text',
  AUDIO = 'audio'
}

// 发言者枚举
export enum Speaker {
  USER = 'user',
  AI = 'ai'
}

// 会话信息接口
export interface SessionInfo {
  id: string;
  session_token: string;
  scenario_id: string;
  scenario_name: string;
  status: number;
  status_name: string;
  created_at: string;
  updated_at: string;
  current_step_id?: string;
  round_number: number;
}

// 消息信息接口
export interface MessageInfo {
  id: string;
  round_number: number;
  speaker: Speaker;
  message_type: MessageType;
  content: string;
  audio_file_path?: string;
  audio_duration?: number;
  tts_voice_id?: string;
  asr_confidence?: number;
  step: {
    id: string;
    name: string;
  };
  timestamp: string;
  ai_hint?: any;
}

// 会话列表响应
export interface SessionListResponse {
  list: SessionInfo[];
  total: number;
  current: number;
  pageSize: number;
}

// 消息列表响应
export interface MessageListResponse {
  list: MessageInfo[];
  total: number;
  current: number;
  pageSize: number;
  session_info: {
    id: string;
    session_token: string;
    scenario_name: string;
    status: number;
    status_name: string;
  };
}

// 查询参数
export interface SessionQuery {
  scenario_id: string;
  status?: number;
  page?: number;
  pageSize?: number;
}

export interface MessageQuery {
  page?: number;
  pageSize?: number;
}

/**
 * 获取用户在特定场景下的会话列表
 */
export function getMyScenarioSessions(params: SessionQuery): Promise<BaseResponse<SessionListResponse>> {
  return apiRequest<SessionListResponse>('/conversations/my-scenario-sessions', {
    method: 'GET',
    params,
  });
}

/**
 * 获取会话详情（通过session token）
 */
export function getSessionDetail(sessionToken: string): Promise<BaseResponse<any>> {
  return apiRequest<any>(`/conversations/sessions/${sessionToken}/detail`, {
    method: 'GET',
  });
}

/**
 * 获取会话详情（通过session ID）
 */
export function getSessionDetailById(sessionId: string): Promise<BaseResponse<any>> {
  return apiRequest<any>(`/conversations/sessions/${sessionId}/detail`, {
    method: 'GET',
  });
}

/**
 * 获取会话消息列表
 */
export function getSessionMessages(sessionToken: string, params?: MessageQuery): Promise<BaseResponse<MessageListResponse>> {
  return apiRequest<MessageListResponse>(`/conversations/sessions/${sessionToken}/messages`, {
    method: 'GET',
    params,
  });
}

/**
 * 创建新会话
 */
export function createSession(data: {
  scenario_id: string;
  ai_role_id?: string;
  language_code?: string;
}): Promise<BaseResponse<any>> {
  return apiRequest<any>('/sessions', {
    method: 'POST',
    data,
  });
}

/**
 * 发送消息
 */
export function sendMessage(data: {
  session_token: string;
  content: string;
  message_type?: MessageType;
  audio_file_path?: string;
  audio_duration?: number;
}): Promise<BaseResponse<any>> {
  return apiRequest<any>('/sessions/messages', {
    method: 'POST',
    data,
  });
}